<template lang="pug">
div.wrapper
  canvas#deck(ref='deck', @click='onDeckClick')
  div(:style='landingStyle')
    canvas#landing(ref='landing', @click='onDeckClick' v-show="!isReplacing")
  div
    p Clock
    span(v-if="$state.isPaused")
      | PAUSED
    span(v-else)
      | {{ clock || "N/A" }}
  div
    p Loops
    span
      | {{ $state.loops }}
</template>

<script>
import { RW, shuffle } from "@/utils"
import CanvasGen from "@/canvas"

let pieces = ["lh", "lv", "br", "tr", "bl", "tl", "jv", "jh", "cr"]
let padding = 10
let penalty = 25
// dc= deck context | lc = landing context
let dc = null
let lc = null
let landingColor = "#b82e2e"
export default {
  name: "SideDeck",
  components: {},
  props: {
    total: { type: Number, default: 4 },
    active: { type: String },
    clock: { type: Number }
  },

  watch: {
    deck() {
      this.drawDeck()
    },
    active() {
      this.drawLanding()
    },
    isReplacing() {}
  },
  data() {
    return {
      deck: [],
      loops: 0
    }
  },
  created() {
    this.canvasTiles = CanvasGen(this.$state.scale, this.$state.scale * this.$tileSize, this.$state.scale * this.$dropSize)
  },
  mounted() {
    this.initializeDeck()
    this.initializeLanding()
  },
  methods: {
    initializeDeck() {
      // console.log("initializeDeck")

      let dp = this.deckPadding
      let canvas = this.$refs.deck

      this.deckHeight = canvas.height = (this.size + dp) * this.total + dp
      this.deckWidth = canvas.width = this.size + dp * 2

      dc = canvas.getContext("2d")

      this.deck = [...shuffle(pieces)].slice(0, this.visibleCount)
    },
    initializeLanding() {
      let canvas = this.$refs.landing
      canvas.width = canvas.height = this.size + this.deckPadding * 2
      lc = canvas.getContext("2d")

      this.$emit("update:active", this.getRandomPiece())
    },
    getRandomPiece() {
      var arr = [
        { p: "lh", w: 4 },
        { p: "lv", w: 4 },
        { p: "br", w: 4 },
        { p: "tr", w: 4 },
        { p: "bl", w: 4 },
        { p: "tl", w: 4 },
        { p: "cr", w: 3 },
        { p: "jv", w: 1 },
        { p: "jh", w: 1 }
      ]

      let value = RW(arr, x => x.w)
      return value.p
    },
    onDeckClick() {
      if (this.$state.score > 0 || this.$state.clock > 1) {
        this.advanceDeck()
        this.drawDeck()
        // incur penalty for passing
        this.$state.score -= penalty
      }
    },
    advanceDeck() {
      // console.log("advanceDeck")
      this.$emit("update:active", this.deck[this.visibleCount - 1])

      let rp = this.getRandomPiece()
      // never have 3 of the same pieces
      if (this.visibleCount > 1)
        while (this.deck[0] == rp && this.deck[1] == rp) {
          rp = this.getRandomPiece()
        }
      // add new piece at the beginning of the array
      this.deck.unshift(rp)

      this.deck = this.deck.slice(0, this.visibleCount)
    },
    drawDeck() {
      // console.log("drawDeck")
      let dp = this.deckPadding
      let dh = dc.canvas.height
      let dw = dc.canvas.width
      let ts = this.size + dp

      dc.fillStyle = "silver"
      dc.fillRect(0, 0, dw, dh)

      this.deck.forEach((p, index) => {
        let _c = this.canvasTiles[p]
        try {
          dc.drawImage(_c, dp, index * ts + dp)
        } catch (e) {
          console.error("piece:", p, e)
        }
      })
    },
    drawLanding() {
      // console.log("drawLanding")
      let dp = this.deckPadding
      let ts = this.size + dp * 2
      let _c = this.canvasTiles[this.active]

      lc.fillStyle = landingColor
      lc.fillRect(0, 0, ts, ts)
      lc.drawImage(_c, dp, dp)
    }
  },
  computed: {
    isPaused() {
      return this.$state.isPaused
    },
    isRunning() {
      return this.$state.isRunning
    },
    size() {
      return this.$state.scale * this.$tileSize
    },
    visibleCount() {
      return this.$state.visibleOnDeck
    },
    isReplacing() {
      return this.$state.isReplacing
    },
    landingStyle() {
      return {
        height: `${this.size + this.deckPadding * 2}px`,
        width: `${this.size + this.deckPadding * 2}px`,
        "background-color": landingColor,
        "margin-top": `50px`
      }
    },
    deckPadding() {
      return padding * this.$state.scale
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  padding-right: 10px;
}
</style>
